import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { formatLabel } from "../../../utils/commonUtils";
import { useResponsiveStyles } from "../../../styles/useResponsiveStyles";

const FilterTags = ({ initialFilters, onFilterRemove }) => {
    const [filters, setFilters] = useState([]);
    const { getFontSize, getContainerHeight } = useResponsiveStyles();

    useEffect(() => {
        setFilters(initialFilters);
    }, [initialFilters]);

    const removeFilter = (filterName, filterValue) => {
        setFilters((prevFilters) => {
            const updatedFilters = prevFilters?.filter(
                (filter) =>
                    !(
                        filter.name === filterName &&
                        filter.value === filterValue
                    )
            );
            return updatedFilters;
        });
        onFilterRemove(filterName, filterValue); // Notify parent to update globally with specific value
    };

    return (
        <div
            className="filter-container"
            style={getContainerHeight("filter-container")}
        >
            {filters.length ? (
                filters.map((filter, index) => (
                    <div
                        className="filter-tag"
                        key={`${filter.name}-${filter.value}-${index}`}
                    >
                        <span
                            className="filter-name"
                            aria-label={`Filter name: ${filter.name}`}
                            // style={getFontSize("body1")}
                        >
                            {formatLabel(filter.name)} :
                        </span>

                        <span
                            className="filter-value"
                            aria-label={`Filter value: ${filter.value}`}
                        >
                            {filter.value}
                        </span>
                        <button
                            className="remove-filter-btn"
                            onClick={() =>
                                removeFilter(filter.name, filter.value)
                            }
                            aria-label={`Remove filter ${filter.name} with value ${filter.value}`}
                        >
                            &times;
                        </button>
                    </div>
                ))
            ) : (
                <span className="empty-text">No Filters Selected</span>
            )}
        </div>
    );
};

FilterTags.propTypes = {
    initialFilters: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.arrayOf(PropTypes.string),
            ]).isRequired,
        })
    ).isRequired,
    onFilterRemove: PropTypes.func.isRequired,
};

export default FilterTags;
